import { useMutation } from '@tanstack/react-query'
import { addTokhatm, createKhatm } from './khatm.action'
import { CreateKhatmPayload } from './khatm.type'

export const useAddToKhatm = (id: number) => {
  return useMutation({
    mutationFn: ({ count }: { count: string }) => addTokhatm({ id, count }),
  })
}

export const useCreateKhatm = () => {
  return useMutation({
    mutationFn: (payload: CreateKhatmPayload) => createKhatm(payload),
  })
}
